import React from 'react';
import { Container, Box, Grid, Typography } from '@material-ui/core';
import { Link } from '@material-ui/core';
import withWidth, { isWidthDown } from '@material-ui/core/withWidth';
import { makeStyles } from '@material-ui/core/styles';
import CenterLayout from './CenterLayout';
import BgWrap from './BgWrap';

const useStyles = makeStyles((theme) => ({
  headingStyle: ({ isEmbed }) => ({
    '& > *': {
      color: isEmbed ? null : theme.palette.primary.contrastText,
      margin: 0,
      // marginBottom: '0.5em'
    },
  }),
  linkContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: theme.spacing(0.5),
    textAlign: 'right',
  },
  textColor: {
    color: theme.palette.primary.contrastText,
  },
}));
const Search = (props) => {
  const {
    children,
    editable,
    headingSite = '<h3>Find a site near you.</h3>',
    headingCountry,
    layout = 10,
    linkLabel,
    onLinkClick,
    isEmbed,
    canViewByCountry = false,
  } = props;
  const classes = useStyles({ isEmbed });

  return (
    <BgWrap layout={layout} empty={isEmbed}>
      <div
        style={editable ? { display: 'block' } : { display: 'none' }}
        className="editable-wrap"
      >
        <Typography
          data-field="find_location_message"
          component="div"
          className={classes.headingStyle + ' ' + 'editable'}
          dangerouslySetInnerHTML={{ __html: headingSite }}
          gutterBottom
        ></Typography>
      </div>
      {!editable && (
        <Typography
          component="p"
          className={classes.headingStyle}
          dangerouslySetInnerHTML={{ __html: headingCountry }}
          gutterBottom
        ></Typography>
      )}
      <Grid
        container
        justify={isWidthDown('sm', props.width) ? 'flex-end' : 'center'}
        spacing={2}
        alignItems="center"
      >
        {children}
      </Grid>
      {canViewByCountry && (
        <div className={classes.linkContainer}>
          <Link
            href="#"
            onClick={onLinkClick}
            variant="caption"
            underline="always"
          >
            {linkLabel}
          </Link>
        </div>
      )}
    </BgWrap>
  );
};

export default withWidth()(Search);
